
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
data () {
return {
currentItem: null,
queryResult: [],
expendClass: 'fa fa-angle-double-down',
dropdownTitle: '点此展开'
}
},
methods: {
async showDesc (index) {
try {
let current = this.queryResult[index]
this.$router.replace({path: 'ImportTariffDetail', query: {p_code: current.CODE_TS, p_name: current.G_NAME}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async expend () {
if (this.expendClass === 'fa fa-angle-double-up') {
this.queryResult = []
this.expendClass = 'fa fa-angle-double-down'
this.dropdownTitle = '点击展示'
return
}
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/HandBook/SearchByCodeTS'
, {params: {codets: this.$route.query.p_code}})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
if (this.queryResult.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
this.expendClass = 'fa fa-angle-double-up'
this.dropdownTitle = '点此收起'
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
async activated () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/HandBook/Detail', {params: {p_code: this.$route.query.p_code}})
console.log(this.$route.query)
this.currentItem = queryPromise.data
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
}



// WEBPACK FOOTER //
// ./src/components/ImportTariffDetail.vue